// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__202Jj","right":"styles_right__3ciUH"};